// extracted by mini-css-extract-plugin
export var label = "_an-1";
export var reminder = "_an-0";